export default __webpack_public_path__ + "static/media/envsensor_realtime_aqhi.f8611a4f.svg";